import { useContext } from 'react'
import { ProjectContext, UserContext } from '../../contexts'
import Heading from '../../ui/Heading'
import JsonPreview from '../../ui/JsonPreview'
import { useTranslation } from 'react-i18next'
import { flattenUser } from '../../ui/utils'
import { checkProjectRole } from '../../utils'
import api from '../../api'

export default function UserDetail() {
    const { t } = useTranslation()
    const [user, setUser] = useContext(UserContext)
    const [project] = useContext(ProjectContext)

    const handleUpdate = async (updatedUser: Record<string, any>) => {
        const { anonymous_id, external_id, email, phone, timezone, locale, devices, created_at, ...rest } = updatedUser
        const shouldUpdateEmail = email !== user.email && email !== undefined
        const shouldUpdatePhone = phone !== user.phone && phone !== undefined
        const newUser = await api.users.update(project.id, user.id, {
            ...(shouldUpdateEmail && { email }),
            ...(shouldUpdatePhone && { phone }),
            ...(timezone && { timezone }),
            ...(locale && { locale }),
            data: rest,
        })
        setUser(newUser)
    }

    const canEdit = (path: Array<string | number>) => {
        if (path.includes('devices')
            || path.includes('id')
            || path.includes('external_id')
            || path.includes('created_at')) {
            return false
        }
        if (checkProjectRole('admin', project.role)) {
            return true
        }
        return !path.includes('email')
            && !path.includes('phone')
    }

    return <>
        <Heading size="h3" title={t('details')} />
        <section className="container">
            <JsonPreview
                value={flattenUser(user)}
                onChange={async (_, patch) => await handleUpdate(patch)}
                editable={canEdit}
                addable={canEdit}
            />
        </section>
    </>
}
